import localforage from 'localforage';

/**
 * Stores and object into local cache.
 * @param {string} key Storage key
 * @param {any} data Data to be stored
 */
export async function saveToLocalCache(key, data) {
  validateKey(key);
  await localforage.setItem(key, data);
  return;
}

/**
 * Retrieves an object from local cache given a key
 * @param {string} key Storage key
 */
export async function getFromLocalCache(key) {
  validateKey(key);
  return await localforage.getItem(key);
}

/**
 * Removes object from local cache given a key
 * @param {string} key Storage key
 */
export async function removeFromLocalCache(key) {
  validateKey(key);
  await localforage.removeItem(key);
  return;
}

function validateKey(key) {
  if (typeof key !== 'string') {
    throw new Error('Invalid key. Key must be a string.');
  }
}



// WEBPACK FOOTER //
// ./src/utils/catering.js